import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const doOptions = {
  triggers: [],
  // might make the transparecy an ACF option for all modules for more flexibility (colour way + bg: solid/transparent)
  transparentModules: ['hero-module', 'hero-image', 'video-player'],

  resetClass: (element = null) => {
    if (element != null) {
      element.classList.remove('option-1', 'option-2', 'option-3', 'option-4', 'option-5', 'option-6');
    }
  },
  getOptionForSection: (section) => {
    const explicitOption = section.getAttribute('data-option');
    if (explicitOption && ['1', '2', '3', '4', '5', '6'].includes(explicitOption)) {
      return explicitOption;
    }

    const isTransparentHeader = doOptions.transparentModules.some((className) =>
      section.classList.contains(className)
    );
    const hasRedText = section.classList.contains('text-red');

    if (hasRedText) {
      return isTransparentHeader ? '1' : '2';
    }

    return isTransparentHeader ? '3' : '4';
  },

  doTheOptions: (elements = null) => {
    if (!elements || elements.length === 0) return;

    const body = document.body;
    if (!body) return;

    doOptions.destroyOptions();

    elements.forEach(element => {
      const option = doOptions.getOptionForSection(element);
      const trigger = ScrollTrigger.create({
        trigger: element,
        start: 'top 5%',
        end: 'bottom 5%',
        onEnter: () => {
          doOptions.resetClass(body);
          body.classList.add(`option-${option}`);
        },
        onEnterBack: () => {
          doOptions.resetClass(body);
          body.classList.add(`option-${option}`);
        },
      });

      doOptions.triggers.push(trigger);
    });

    ScrollTrigger.refresh();
  },
  destroyOptions: () => {
    doOptions.resetClass(document.body);
    doOptions.triggers.forEach(trigger => {
      trigger.kill();
    });
    doOptions.triggers = [];
  }
};

export default doOptions;
